import { FC, ReactNode } from 'react';
import { StyledButton } from './AlertButton.styled';

interface AlertButtonProps {
  children?: ReactNode;
  onClick: () => void;
}

const AlertButton: FC<AlertButtonProps> = ({ children, onClick }) => {
  return (
    <StyledButton
      bsStyle="link"
      data-testid="select-invalid-locale-button"
      onClick={onClick}
    >
      {children}
    </StyledButton>
  );
};

AlertButton.defaultProps = {
  children: null,
};

export default AlertButton;
